import { connect } from 'react-redux';
import LicenseDetailTabs from './LicenseDetailTabs';
import {
    getApplicationDetailBegin,
    getAuditHistoryListBegin,
    getViolationListBegin,
    getInspectionListBegin,
    getCategoryListBegin,
    getCommentListBegin,
    addCommentBegin,
    addViolationBegin,
    getUserListBegin,
    getLicenseAccountingBegin,
    setActiveTab,
    getInspectionDetailBegin,
    updateLicenseBegin,
    deleteViolationBegin,
    addInspectionBegin,
    deleteInspectionRecordBegin,
} from '../../store/actions/license.actions';
import {
    getApplicationDetail,
    getApplicationEditForm,
    getApplicationListLoading,
    getCategoryList,
    getUserList,
    getInspectionType,
    getInspectionEditForm,
    getInspectionItem,
    getApplicationPersonDetails,
    getLicenseType,
    getInspectionList,
    getInspectionListLoadingStatus,
    getLoadMoreInspection,
    getLoadMoreViolation,
    getLoadMoreCommentList,
    getLoadMoreAccountingList,
    getViolationList,
    getViolationsListLoadingStatus,
    getAuditHistoryList,
    getAuditHistoryListStatus,
    getAuditHistoryHasMore,
    getLicenseTabs,
} from '../../store/selectors/license.selectors';
import { getSiteFeaturesList } from '../../store/selectors/site.selectors';
import { getLoggedInUser } from '../../store/selectors/authentication.selectors';

const mapStateToProps = (state: any) => {
    const application = getApplicationDetail(state);
    const licenseType = getLicenseType(state);
    const editForm = getApplicationEditForm(state);
    const isLoading = getApplicationListLoading(state);
    const appSiteFeatureList = getSiteFeaturesList(state);
    const violationCategories = getCategoryList(state);
    const users = getUserList(state);
    const inspectionTypesList = getInspectionType(state);
    const inspectionItem = getInspectionItem(state);
    const inspectionEditForm = getInspectionEditForm(state);
    const personDetail = getApplicationPersonDetails(state);
    const inspectionList = getInspectionList(state);
    const inspectionListLoading = getInspectionListLoadingStatus(state);
    const hasMoreInspection = getLoadMoreInspection(state);
    const hasMoreViolation = getLoadMoreViolation(state);
    const loggedInUser = getLoggedInUser(state);
    const hasMoreLicenseComments = getLoadMoreCommentList(state);
    const violations = getViolationList(state);
    const violationsLoading = getViolationsListLoadingStatus(state);
    const hasMoreAccounting = getLoadMoreAccountingList(state);
    const historyList = getAuditHistoryList(state);
    const historyLoading = getAuditHistoryListStatus(state);
    const hasMoreHistory = getAuditHistoryHasMore(state);
    const configuredTabs = getLicenseTabs(state);

    return {
        application,
        licenseType,
        editForm,
        isLoading,
        applicationStatus: application.status,
        applicationPersonAddressStringify: JSON.stringify(application?.person?.address),
        appSiteFeatureList,
        violationCategories,
        users,
        inspectionTypesList,
        inspectionEditForm,
        inspectionItem,
        personDetail,
        inspectionList,
        inspectionListLoading,
        hasMoreInspection,
        hasMoreViolation,
        loggedInUser,
        hasMoreLicenseComments,
        hasMoreAccounting,
        violations,
        violationsLoading,
        historyList,
        historyLoading,
        hasMoreHistory,
        configuredTabs,
    };
};

const mapDispatchToProps = {
    getApplication: getApplicationDetailBegin,
    getLicenseAccounting: getLicenseAccountingBegin,
    getAuditHistoryList: getAuditHistoryListBegin,
    updateLicense: updateLicenseBegin,
    getViolationList: getViolationListBegin,
    getInspectionList: getInspectionListBegin,
    getCommentList: getCommentListBegin,
    getCategoryList: getCategoryListBegin,
    addViolation: addViolationBegin,
    addComment: addCommentBegin,
    getUserList: getUserListBegin,
    setActiveTab: setActiveTab,
    getInspectionDetail: getInspectionDetailBegin,
    deleteViolation: deleteViolationBegin,
    addInspection: addInspectionBegin,
    deleteInspection: deleteInspectionRecordBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseDetailTabs);
